/* istanbul ignore file */
import { ErrorBoundary } from "react-error-boundary";
import { StaticPagesContext } from "../interceptors";
import { useLogger } from "@amzn/xb-hooks";
import { useContext } from "react";
import { XBError } from "./federationUtils";

export const HostSideErrorBoundary = ({
  experienceProviderName,
  componentName,
  children,
}: {
  experienceProviderName: string;
  componentName: string;
  children: React.ReactNode;
}) => {
  const { log } = useLogger();
  const pages = useContext(StaticPagesContext);
  const E500Page = pages["E500"];
  const handleError = (error: Error) => {
    log.error(
      `Error loading ${componentName} from ${experienceProviderName}. Error message: ${error?.message}`,
      new XBError({ error, name: "RemoteComponentInitializationError" })
    );
  };

  return (
    <ErrorBoundary fallback={<E500Page pageCode={"E500"} />} onError={handleError}>
      {children}
    </ErrorBoundary>
  );
};
